import React from 'react';
import { mapModifiers } from 'libs/component';
import Link from 'next/link';
import { Icon } from 'components/atoms/icon';

export interface BackButtonProps {
  path?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ path = '/' }) => (
  <div className={mapModifiers('a-back-button')}>
    <Link href={path} scroll={true}>
      <a>
        <span>BACK</span>
        <Icon name="arrow-left-large" color="dark-navy" />
      </a>
    </Link>
  </div>
);
